import {
  MenuBook,
  Settings,
 
  Assessment,
  Api,
  DataObject,

  Storage,
  Build,
  PlayArrow,
  History,
  ViewList,

  Edit,

  Error,

  Tune,

  ApiOutlined,

  ViewModule,

  SettingsApplications,

} from "@mui/icons-material";

export const documentationStructure = [
  {
    title: "Test Studio",
    icon: <MenuBook />,
    children: [
      {
        title: "Test Scenario Settings",
        path: "test-studio/settings",
        file: "test-studio/settings.md",
        icon: <Settings />,
        children: [
          {
            title: "Environment",
            path: "test-studio/settings/environment",
            file: "test-studio/settings/environment.md",
          },
          {
            title: "Description",
            path: "test-studio/settings/description",
            file: "test-studio/settings/description.md",
          },
          {
            title: "Browser",
            path: "test-studio/settings/browser",
            file: "test-studio/settings/browser.md",
          },
          {
            title: "Screen Resolution",
            path: "test-studio/settings/screen-resolution",
            file: "test-studio/settings/screen-resolution.md",
          },
          {
            title: "Run Options",
            path: "test-studio/settings/run-options",
            file: "test-studio/settings/run-options.md",
          },
          {
            title: "Performance Settings",
            path: "test-studio/settings/performance",
            file: "test-studio/settings/performance.md",
          },
        ],
      },
      {
        title: "Test Scenario Options",
        path: "test-studio/options",
        file: "test-studio/options.md",
        icon: <Build />,
        children: [
          {
            title: "Basic Operations",
            path: "test-studio/options/basic-operations",
            file: "test-studio/options/basic-operations.md",
          },
          {
            title: "Flow Management",
            path: "test-studio/options/flow-management",
            file: "test-studio/options/flow-management.md",
          },
          {
            title: "Advanced Features",
            path: "test-studio/options/advanced-features",
            file: "test-studio/options/advanced-features.md",
          },
          {
            title: "Test Suite Integration",
            path: "test-studio/options/test-suite-integration",
            file: "test-studio/options/test-suite-integration.md",
          },
          {
            title: "Test Step Management",
            path: "test-studio/options/test-step-management",
            file: "test-studio/options/test-step-management.md",
          },
        ],
      },
      {
        title: "Edit Window Options",
        path: "test-studio/edit-window",
        file: "test-studio/edit-window.md",
        icon: <Edit />,
        children: [
          {
            title: "Test Data Configuration",
            path: "test-studio/edit-window/test-data-config",
            file: "test-studio/edit-window/test-data-config.md",
          },
          {
            title: "Element Details",
            path: "test-studio/edit-window/element-details",
            file: "test-studio/edit-window/element-details.md",
          },
          {
            title: "Element Locator",
            path: "test-studio/edit-window/element-locator",
            file: "test-studio/edit-window/element-locator.md",
          },
          {
            title: "Scripts",
            path: "test-studio/edit-window/scripts",
            file: "test-studio/edit-window/scripts.md",
          },
          {
            title: "API Configuration",
            path: "test-studio/edit-window/api-config",
            file: "test-studio/edit-window/api-config.md",
          },
          {
            title: "Conditional Logic",
            path: "test-studio/edit-window/conditional-logic",
            file: "test-studio/edit-window/conditional-logic.md",
          },
        ],
      },
    ],
  },
  {
    title: "Execution Reports",
    icon: <Assessment />,
    children: [
      {
        title: "Reports Overview",
        path: "execution/reports/overview",
        file: "execution/reports/overview.md",
        icon: <ViewList />,
      },
      {
        title: "Current Executions",
        path: "execution/reports/current",
        file: "execution/reports/current.md",
        icon: <PlayArrow />,
      },
      {
        title: "Execution History",
        path: "execution/reports/history",
        file: "execution/reports/history.md",
        icon: <History />,
      },
      {
        title: "Execution Summary",
        path: "execution/reports/summary",
        file: "execution/reports/summary.md",
        icon: <Assessment />,
      },
      {
        title: "Failure Analysis",
        path: "execution/reports/failure-analysis",
        file: "execution/reports/failure-analysis.md",
        icon: <Error />,
      },
    ],
  },
  {
    title: "Test Suites",
    icon: <ViewModule />,
    children: [
      {
        title: "Suite Management",
        path: "test-suites/management",
        file: "test-suites/management.md",
        icon: <SettingsApplications />,
        children: [
          {
            title: "View Test Cases",
            path: "test-suites/management/view-cases",
            file: "test-suites/management/view-cases.md",
          },
          {
            title: "View Test Suites",
            path: "test-suites/management/view-suites",
            file: "test-suites/management/view-suites.md",
          },
          {
            title: "Suite Operations",
            path: "test-suites/management/operations",
            file: "test-suites/management/operations.md",
          },
        ],
      },
      {
        title: "Suite Settings",
        path: "test-suites/settings",
        file: "test-suites/settings.md",
        icon: <Tune />,
        children: [
          {
            title: "Run Parameters",
            path: "test-suites/settings/run-parameters",
            file: "test-suites/settings/run-parameters.md",
          },
          {
            title: "Integration",
            path: "test-suites/settings/integration",
            file: "test-suites/settings/integration.md",
          },
          {
            title: "Variables",
            path: "test-suites/settings/variables",
            file: "test-suites/settings/variables.md",
          },
          {
            title: "Scheduler",
            path: "test-suites/settings/scheduler",
            file: "test-suites/settings/scheduler.md",
          },
        ],
      },
    ],
  },
  {
    title: "API Management",
    icon: <Api />,
    children: [
      {
        title: "API Overview",
        path: "api-management/overview",
        file: "api-management/overview.md",
        icon: <ApiOutlined />,
      },
      {
        title: "API Operations",
        path: "api-management/operations",
        file: "api-management/operations.md",
        icon: <Build />,
        children: [
          {
            title: "Create API",
            path: "api-management/operations/create",
            file: "api-management/operations/create.md",
          },
          {
            title: "API Testing",
            path: "api-management/operations/testing",
            file: "api-management/operations/testing.md",
          },
          {
            title: "Request Configuration",
            path: "api-management/operations/request-config",
            file: "api-management/operations/request-config.md",
          },
        ],
      },
    ],
  },
  {
    title: "Test Data Management",
    icon: <Storage />,
    children: [
      {
        title: "Data Operations",
        path: "test-data/operations",
        file: "test-data/operations.md",
        icon: <DataObject />,
        children: [
          {
            title: "Create Data",
            path: "test-data/operations/create",
            file: "test-data/operations/create.md",
          },
          {
            title: "Refresh Data",
            path: "test-data/operations/refresh",
            file: "test-data/operations/refresh.md",
          },
          {
            title: "Custom Functions",
            path: "test-data/operations/custom-functions",
            file: "test-data/operations/custom-functions.md",
          },
        ],
      },
    ],
  },
]; 